/**
 * File: CallToAction.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.0.1
 * Created: 2025-08-01
 * Last Updated: 2026-02-06
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function CallToAction({ label, headline, description, buttons }) {
    return (
        <>
            <div className="cta">
                <div className="cta__message">
                    <h4>{label}</h4>
                    <h2>{headline}</h2>
                    <p>{description}</p>
                </div>
                {buttons}
            </div>
        </>
    );
}

export default CallToAction;
